var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotSvgrepoCom1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(11, 127, 158)"
    },
    d: "M 358.895 162.073 C 358.895 276.981 300.702 399.07 236.384 399.07 C 172.065 399.07 113.872 277.634 113.872 162.073 C 113.872 46.512 172.678 21.05 236.384 21.05 C 300.09 21.05 358.895 47.165 358.895 162.073 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(11, 99, 130)"
    },
    d: "M 236.384 21.05 C 300.09 21.05 358.895 47.165 358.895 162.073 C 358.895 276.981 300.702 399.07 236.384 399.07 C 172.065 399.07 113.872 277.634 113.872 162.073"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 35, 63)"
    },
    d: "M 236.384 21.05 C 300.09 21.05 358.895 47.165 358.895 162.073 C 358.895 276.981 300.702 399.07 236.384 399.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(2, 39, 40)"
    },
    d: "M 207.594 86.338 C 207.594 97.437 199.018 115.065 187.992 115.065 C 177.578 115.065 168.39 98.09 168.39 86.338 C 168.39 75.239 176.966 65.446 187.992 65.446 C 198.405 65.446 207.594 74.587 207.594 86.338 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    cx: 206.62,
    cy: 73.069,
    r: 25.6,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    d: "M 173.903 71.322 C 181.254 63.487 193.505 63.487 201.468 71.322 C 208.819 79.157 208.819 92.214 201.468 100.702"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    cx: 206.62,
    cy: 73.069,
    r: 14.4,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    d: "M 187.992 98.09 C 181.866 98.09 176.966 92.867 176.966 86.338 C 176.966 79.81 181.866 74.587 187.992 74.587"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBFFFD"
    },
    cx: 179.2,
    cy: 68.8,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBFFFD"
    },
    cx: 204.8,
    cy: 92.8,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(11, 99, 130)"
    },
    d: "M 304.378 86.338 C 304.378 97.437 295.802 115.065 284.776 115.065 C 274.362 115.065 265.174 98.09 265.174 86.338 C 265.174 75.239 273.75 65.446 284.776 65.446 C 295.802 65.446 304.378 74.587 304.378 86.338 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    cx: 333.02,
    cy: 73.069,
    r: 25.6,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    d: "M 271.3 71.322 C 278.65 63.487 290.902 63.487 298.865 71.322 C 306.215 79.157 306.215 92.214 298.865 100.702"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    cx: 333.02,
    cy: 73.069,
    r: 14.4,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    d: "M 284.776 98.09 C 278.65 98.09 273.75 92.867 273.75 86.338 C 273.75 79.81 278.65 74.587 284.776 74.587"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBFFFD"
    },
    cx: 305.6,
    cy: 68.8,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBFFFD"
    },
    cx: 331.2,
    cy: 92.8,
    r: 4
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(145, 198, 194)"
    },
    cx: 236.384,
    cy: 425.186,
    rx: 79.633,
    ry: 9.793
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    d: "M 188.604 136.611 L 162.877 103.966 L 115.71 103.966 C 115.097 110.495 114.485 117.024 114.485 117.024 L 157.976 117.024 L 187.379 149.668 L 230.258 149.668 L 230.258 136.611 L 188.604 136.611 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    points: "113.872 117.024 157.976 117.024 187.379 149.668 187.379 149.668 187.379 149.668 230.258 149.668 230.258 145.751 187.992 141.834 162.877 110.495 162.877 110.495"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    d: "M 284.163 136.611 L 309.891 103.966 L 357.058 103.966 C 357.67 110.495 358.283 117.024 358.283 117.024 L 314.791 117.024 L 285.388 149.668 L 242.509 149.668 L 242.509 136.611 L 284.163 136.611 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    points: "358.895 117.024 314.791 117.024 285.388 149.668 285.388 149.668 285.388 149.668 242.509 149.668 242.509 145.751 284.776 141.834 309.891 110.495 309.891 110.495"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    cx: 269.82,
    cy: 140.269,
    r: 16,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    d: "M 248.635 141.181 C 248.635 148.362 243.122 154.238 236.384 154.238 C 229.646 154.238 224.133 148.362 224.133 141.181"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(11, 127, 158)"
    },
    d: "M 114.485 162.726 L 113.872 161.42 C 113.872 162.073 113.26 162.073 113.26 162.726 C 113.26 239.113 137.762 316.807 174.516 361.203 L 174.516 184.924 L 151.851 162.726 L 114.485 162.726 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 35, 63)"
    },
    d: "M 114.485 158.156 L 113.872 159.462 C 113.872 160.114 113.26 161.42 113.26 162.073 C 113.26 238.461 137.762 317.46 174.516 361.856 L 174.516 182.312"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(11, 127, 158)"
    },
    d: "M 357.67 162.726 L 358.283 161.42 C 358.283 162.073 358.895 162.073 358.895 162.726 C 358.895 239.113 334.393 313.542 297.64 358.591 L 297.64 184.924 L 320.304 162.726 L 357.67 162.726 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(2, 64, 91)"
    },
    d: "M 358.283 158.156 L 358.283 159.462 C 358.283 160.114 358.895 161.42 358.895 162.073 C 358.895 238.461 334.393 317.46 297.64 361.856 L 297.64 182.312"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(11, 99, 130)"
    },
    cx: 66.62,
    cy: 297.869,
    r: 40.8,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M50.4,264.8c22.4,0,40.8,18.4,40.8,40.8s-18.4,40.8-40.8,40.8"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 50.4,
    cy: 247.2,
    r: 9.6
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    points: "83.244 214.957 83.244 182.312 101.621 182.312 101.621 156.197 113.872 156.197"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.074053, -0.997254, 0.996511, -0.084062, -84.687007, 307.044687)",
    style: {
      fill: "rgb(11, 127, 158)"
    },
    cx: 97.595,
    cy: 209.584,
    rx: 32.634,
    ry: 10.417
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.073959, -0.997261, 0.99652, -0.083955, -88.773158, 302.234689)",
    style: {
      fill: "rgb(11, 99, 130)"
    },
    cx: 92.778,
    cy: 209.609,
    rx: 19.579,
    ry: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 127.2,
    cy: 211.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 140,
    cy: 207.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 152.8,
    cy: 204,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    d: "M 95.496 276.981 C 95.496 278.939 94.27 280.245 92.433 280.245 L 67.93 280.245 C 66.093 280.245 64.868 278.939 64.868 276.981 C 64.868 275.022 66.093 273.716 67.93 273.716 L 92.433 273.716 C 94.27 273.716 95.496 275.022 95.496 276.981 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(11, 99, 130)"
    },
    cx: 473.02,
    cy: 297.869,
    r: 40.8,
    transform: "matrix(0.765697, 0, 0, 0.816106, 29.783078, 26.706755)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M456.8,264.8c-22.4,0-40.8,18.4-40.8,40.8s18.4,40.8,40.8,40.8"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 456.8,
    cy: 247.2,
    r: 9.6
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(22, 216, 216)"
    },
    points: "389.523 214.957 389.523 182.312 371.147 182.312 371.147 156.197 358.895 156.197"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.074053, 0.997254, -0.996511, -0.084062, 595.602191, -198.959341)",
    style: {
      fill: "rgb(11, 127, 158)"
    },
    cx: 410.015,
    cy: 209.81,
    rx: 32.634,
    ry: 10.417
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.073959, 0.997261, -0.99652, -0.083955, 599.50014, -202.844916)",
    style: {
      fill: "rgb(11, 99, 130)"
    },
    cx: 414.238,
    cy: 210.213,
    rx: 19.579,
    ry: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 380,
    cy: 211.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 367.2,
    cy: 207.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#16D8D8"
    },
    cx: 354.4,
    cy: 204,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 255, 242)"
    },
    d: "M 407.9 276.981 C 407.9 275.022 406.675 273.716 404.837 273.716 L 380.335 273.716 C 378.497 273.716 377.272 275.022 377.272 276.981 C 377.272 278.939 378.497 280.245 380.335 280.245 L 404.837 280.245 C 406.675 280.245 407.9 278.939 407.9 276.981 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765697, 0, 0, 0.816106, 42.202737, 21.050248)",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSvgrepoCom1);
export default __webpack_public_path__ + "static/media/robot-svgrepo-com (1).95a008112716c3ee68a429a99de4da2c.svg";
export { ForwardRef as ReactComponent };